import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

import { truncate } from "../../styles";
import { Flexbox } from "../Flexbox.styles";

export const LensRowComponent = styled(Flexbox)<{ selected: boolean }>`
    cursor: pointer;
    padding: ${Spacing["2XS"]}px ${Spacing.XS}px;
    background: ${({ selected }) => (selected ? Colors.Gray.V50 : Colors.WHITE)};
    border-radius: ${BorderRadius.container}px;

    :hover,
    :focus {
        background: ${Colors.Gray.V100};
    }
`;

export const LensIcon = styled.div<{ iconUrl: string }>`
    flex-shrink: 0;

    width: 40px;
    height: 40px;

    background: center 0 / contain no-repeat url(${({ iconUrl }) => iconUrl}) #f7f8f9;
    border-radius: ${BorderRadius.button}px;
`;

export const LensNameContainer = styled(Flexbox)`
    width: 240px;
    padding-left: ${Spacing.SM}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: ${LineHeightInPx.REGULAR}px;
    color: ${Colors.Black.V50};
    ${truncate};
`;

export const checkedIcon = css`
    margin-left: ${Spacing.XS}px;
`;
